import { Box, CircularProgress } from '@mui/material'

export default function MainSpinner() {
  return (
    <Box sx={{
      width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center',
    }}
    >
      <CircularProgress />
    </Box>
  )
}
